<template>
  <div>
    <ThePageHeader :title="'Széchenyi 2020 pályázat'" />

    <div class="text">
      <a
        href="/img/certificates/ginop/kpp_ginop_8_3_5_18.jpg"
        target="_blank"
      >
        <img
          src="/img/certificates/ginop/kpp_ginop_8_3_5_18.jpg"
          style="width: 100%;"
        >
      </a>
    </div>

    <hr style="margin: 100px auto 0 auto; max-width: 1100px;">

    <div class="text">
      <a
        href="/img/certificates/ginop/1_kpp_2017.jpg"
        target="_blank"
      >
        <img
          src="/img/certificates/ginop/1_kpp_2017.jpg"
          style="width: 100%;"
        >
      </a>

      <div>
        <b>Kedvezményezett neve:</b> Kőrös Print Pack Kft.<br>

        <b>A projekt címe:</b> Nyomdaipari fejlesztés a Kőrös Print-Pack Kft.-nél<br>

        <b>A szerződött támogatás összege:</b> 26.352.014 Ft<br>

        <b>A támogatás mértéke:</b> 70 %<br>

        <b>A projekt tartalma:</b> A GINOP-Plusz 1.2.8.20-2020 felhívás
        keretében a Kőrös Print-Pack Kft. 26.352.014 forint feltételesen
        vissza nem térítendő európai uniós támogatásban részesült. A
        Gazdaságfejlesztési és Innovációs Operatív Program Plusz
        segítségével a Kőrös Print-Pack Kft. technológiai fejlesztéseket
        hajtott végre.<br>

        <b>A fejlesztés célja a gyártástechnológia továbbfejlesztése.</b><br>

        <b>A fejlesztés eredményeként a Kőrös Print-Pack Kft.:</b><br>

        <ul>
          <li>
            technológiai fejlesztést eredményező új eszközöket szerez be
          </li>
        </ul>

        <div class="font-weight-bold text-xs-center">
          A fejlesztés célja a modern üzleti és termelési kihívásokhoz
          való alkalmazkodást segítő fejlesztés.<br>
          A projekt tényleges befejezésének dátuma: 2021.04.28.
        </div>

        <div class="text-xs-center">
          <b>A megvalósulás helyszíne:</b><br>
          5600 Békéscsaba Orosházi u.32.<br>

          <b>Kedvezményezett neve:</b> Kőrös Print-Pack Kft.<br>

          A projekt a Széchenyi Terv Plusz program keretében valósult meg 2021. évben.<br>

          <b>Projektazonosító:</b> GINOP-Plusz 1.2.8.20-2020-01364
        </div>
      </div>
    </div>

    <hr style="margin: 100px auto 0 auto; max-width: 1100px;">

    <div class="text">
      <a
        href="/img/certificates/ginop/2_kpp_2017.jpg"
        target="_blank"
      >
        <img
          src="/img/certificates/ginop/2_kpp_2017.jpg"
          style="width: 100%;"
        >
      </a>
    </div>

    <hr style="margin: 100px auto 0 auto; max-width: 1100px;">

    <div class="text">
      <a
        href="/img/certificates/ginop/3_kpp_2018.jpg"
        target="_blank"
      >
        <img
          src="/img/certificates/ginop/3_kpp_2018.jpg"
          style="width: 100%;"
        >
      </a>
    </div>

    <hr style="margin: 100px auto 0 auto; max-width: 1100px;">
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'SzechenyiPlan',
  metaInfo: {
    title: 'Széchenyi 2020 | Körös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: '',
      },
    ],
  },
  components: {
    ThePageHeader,
  },
};
</script>

<style scoped>
.text {
  margin: 100px auto 0 auto;
  width: 1000px;
  max-width: 90vw;
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
}
</style>
